import script from "./ImagesPreviewer.vue?vue&type=script&setup=true&lang=js"
export * from "./ImagesPreviewer.vue?vue&type=script&setup=true&lang=js"

import "./ImagesPreviewer.vue?vue&type=style&index=0&id=cbfca102&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbfca102"]])

export default __exports__